import { render, staticRenderFns } from "./PaymentSlips.vue?vue&type=template&id=3aa0b7f4"
import script from "./PaymentSlips.vue?vue&type=script&lang=ts"
export * from "./PaymentSlips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports